export default __webpack_public_path__ + "static/icon_share.e11579fa9c42bfc2700510694f327662.png";